
export async function acquireLock(key: string): Promise<(() => void) | null> {
    // Try Web Locks API first (atomic, cross-tab)
    if (navigator.locks) {
        return acquireWebLock(key);
    }
    // Fallback for older browsers
    return acquireLocalStorageLock(key);
}

function acquireWebLock(key: string): Promise<(() => void) | null> {
    return new Promise((resolve) => {
        // ifAvailable: true → returns immediately with null if another tab holds the lock
        navigator.locks.request(key, { ifAvailable: true }, (lock) => {
            if (!lock) {
                resolve(null);
                return; // no lock acquired, callback exits immediately
            }
            // Lock acquired — return a promise that stays pending until unlock() is called
            return new Promise<void>((releaseLock) => {
                resolve(releaseLock);
            });
        });
    });
}

async function acquireLocalStorageLock(key: string): Promise<(() => void) | null> {
    const lockKey = `SIMPLE-BROWSER-LOCK-${key}`;
    const owner = crypto.randomUUID();
    const now = Date.now();

    const raw = localStorage.getItem(lockKey);
    if (raw) {
        const { expiresAt } = JSON.parse(raw);
        if (expiresAt > now) return null;
    }

    localStorage.setItem(lockKey, JSON.stringify({ owner, expiresAt: now + 8000 }));

    await new Promise(r => setTimeout(r, (Math.random() * 50) + 30));

    const verify = localStorage.getItem(lockKey);
    if (!verify || JSON.parse(verify).owner !== owner) return null;

    return () => localStorage.removeItem(lockKey);
}
